import { ProgressionServiceFirestore } from "./ProgressionServiceFirestore";
import { ProgressionServiceLocal } from "./ProgressionServiceLocal";
/**
 * Factory for creating ProgressionService instances.
 * Determines whether to use Firestore or Local implementation based on environment.
 */
export class ProgressionServiceFactory {
    static firestoreInstance = null;
    static localInstance = null;
    /**
     * Create a ProgressionService instance.
     * Uses Firestore implementation if firestore is provided, otherwise uses Local implementation.
     *
     * @param firestore - Optional Firestore instance. If not provided, uses Local implementation.
     * @returns ProgressionService instance
     */
    static create(firestore) {
        if (firestore) {
            if (!this.firestoreInstance) {
                this.firestoreInstance = new ProgressionServiceFirestore(firestore);
            }
            return this.firestoreInstance;
        }
        else {
            if (!this.localInstance) {
                this.localInstance = new ProgressionServiceLocal();
            }
            return this.localInstance;
        }
    }
    /**
     * Create a new Local instance (useful for testing).
     * Does not use singleton pattern.
     */
    static createLocal() {
        return new ProgressionServiceLocal();
    }
    /**
     * Create a new Firestore instance.
     * Does not use singleton pattern.
     */
    static createFirestore(firestore) {
        return new ProgressionServiceFirestore(firestore);
    }
    /**
     * Reset singleton instances (useful for testing).
     */
    static reset() {
        this.firestoreInstance = null;
        this.localInstance = null;
    }
}
